export default "__VITE_ASSET__tMhLtblz__"